import { render, staticRenderFns } from "./crearZonas.vue?vue&type=template&id=51ae3dea"
import script from "./crearZonas.vue?vue&type=script&lang=js"
export * from "./crearZonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports